<script setup lang="ts">
import type { ModelRef } from "vue";
import type { TreeNodes } from "~/core/models/TreeNodes.class.ts";
import { useFetchSectors } from "~/modules/sector/composables/useFetchSectors";
import { mapSectorsToTreeNodes } from "~/modules/sector/utils/mapSectorsToTreeNodes";

const { t } = useI18n();

const props = defineProps<{
  organizationCode?: number;
}>();

const { isLoading, error, sectors, getSectors } = useFetchSectors({
  organizationCode: props.organizationCode,
});

const treeSelectElement: Ref<HTMLElement | null> = ref(null);

const treeSelectKey = ref(0);
const lxcTreeNodes = ref<TreeNodes[]>([]);
const checkedSectorCodes: ModelRef<string[]> = defineModel<string[]>({
  default: [],
});

/**
 * Retrieve sectors from Webservices
 */
async function buildSectorTreeNodes() {
  await getSectors();
  if (!error.value && sectors.value.length > 0) {
    lxcTreeNodes.value = mapSectorsToTreeNodes(sectors.value[0]);
  }
}

function onCheckedSectorsChanged(sectorCodes: string[]) {
  checkedSectorCodes.value = sectorCodes;
}

onMounted(async () => {
  await buildSectorTreeNodes();
  treeSelectKey.value += 1;
});
</script>

<template>
  <div ref="treeSelectElement" v-loading="isLoading">
    <tree-select
      :key="treeSelectKey"
      :tree="lxcTreeNodes"
      :default-checked-values="checkedSectorCodes"
      :placeholder="t('layout.menu.sector.placeholder')"
      force-inheritance
      allow-empty-selection
      @on-checked-node-value-changed="onCheckedSectorsChanged"
    />
  </div>
</template>
